module.exports = __webpack_public_path__ + "static/media/Badge_Pediatrie.b30cd8b7.png";